import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Dialog, DialogActions, DialogContent, DialogContentText, MenuItem, Popover, Select, TextField,Button } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function SettingForm(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();

    const isFormKnowledge = [
        Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE,
        Constant.FILTER_LIST_FORM_TYPE.FORM_MASTER
    ].includes(props.addFormType);

    const isTaskForm = [Constant.FILTER_LIST_FORM_TYPE.FORM_TASK].includes(props?.addFormType);

    const [open,setOpen] = useState(false);
    const handleCloseConfirmModal = () => {
        setOpen(false);
    }
    const name = Utils.convertJSONDataToObject(props?.currentAddField?.name)
    let fieldListInUsingProject = Utils.isEmptyArray(props.listFieldInProject)
        ? []
        : [...props.listFieldInProject];
    let fieldListAddToForm = Utils.isEmptyArray(props.listFieldAddToForm)
        ? []
        : [...props.listFieldAddToForm];

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);
    let currentFieldData = props.fieldAddList[indexAddField];
    
    if (currentFieldData.sysField || currentFieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW) {
        if (currentFieldData.sysField !== 'listOfSynonyms') {
            currentFieldData.required = !Utils.isEmpty(currentFieldData.structure?.required)
                ? currentFieldData?.structure?.required
                : currentFieldData.required;

            currentFieldData.publicForCustomer = !Utils.isEmpty(
                currentFieldData.structure?.publicForCustomer
            )
                ? currentFieldData.structure?.publicForCustomer
                : currentFieldData.publicForCustomer;
        } else {
            currentFieldData.required = currentFieldData.required
                ? currentFieldData.required
                : currentFieldData?.structure?.required;
            currentFieldData.publicForCustomer = currentFieldData.publicForCustomer
                ? currentFieldData.publicForCustomer
                : currentFieldData.structure?.publicForCustomer;
        }
    }

    const [fieldRequire, setFieldRequire] = useState(
        !Utils.isEmpty(currentFieldData.required)
            ? currentFieldData.required
            : Constant.SETTING_FORM_DEFAULT.REQUIRED
    );

    const getInititalPublicForCustomer = () => {
        if (isFormKnowledge) {
            if (
                !Utils.isEmpty(currentFieldData.publicForCustomer) &&
                currentFieldData.publicForCustomer !== Constant.SETTING_FORM_DEFAULT.READ_ONLY
            ) {
                return currentFieldData.publicForCustomer;
            }
            return Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
        }

        if (!Utils.isEmpty(currentFieldData.publicForCustomer)) {
            return currentFieldData.publicForCustomer;
        }

        if (currentFieldData.sysField === 'attachments') {
            return Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER;
        }
        return Constant.SETTING_FORM_DEFAULT.READ_ONLY;
    };

    const [publicForCustomer, setPublicForCustomer] = useState(getInititalPublicForCustomer())

    const onChangeSettingFieldRequire = () => {
        props.setIsChangeData(true)
        setFieldRequire(!fieldRequire);
    };

    const onChangeSettingPublicForCustomer = event => {
        if (event.target.value === Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW) {
            const field = props?.settingTitle?.find(titleField => {
                return titleField.id === props?.currentAddField?.id;
            });
            if (!Utils.isEmptyObject(field)) {
                setOpen(true);
                return;
            }
        }
        setPublicForCustomer(event.target.value);
        props.setIsChangeData(true);
    };

    const checkDisabledInput = (isPublicForCustomer = true) => {
        let flagDisable = isPublicForCustomer ? currentFieldData.structure?.disablePublicForCustomer : currentFieldData.structure?.disableSettingRequired;
        let isDisabledInput = flagDisable  ? true : false;
        const prefixId = Utils.getPrefixOfId(props.currentAddField.id);
        if ((props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
            props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) &&
            prefixId !== 'dummy' &&
            isDisabledInput === false
        ) {
            let cloneFieldAddToForm = cloneDeep(fieldListAddToForm);
            const indexFieldAddToForm = Utils.findIndexInArrayById(props.currentAddField.id, cloneFieldAddToForm);
            if (indexFieldAddToForm === -1) {
                isDisabledInput = true;
            }
        }
        return isDisabledInput;
    }

    const setCustomerAction = currentFieldName => {
        const isDisabledInput = checkDisabledInput();

        switch (currentFieldName) {
            case 'チケットID':
            case 'エスカレーション元のカスタマー':
                return (
                    <>
                        <TextField
                            className="form-control--wrap form-control--hg32"
                            value={publicForCustomer}
                            disabled={isDisabledInput}
                            select
                            variant="outlined"
                            onChange={event => onChangeSettingPublicForCustomer(event)}
                            data-cy="setting-public-for-customer"
                        >
                            <MenuItem 
                                value={isFormKnowledge ?
                                    Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER: Constant.SETTING_FORM_DEFAULT.READ_ONLY
                                }
                                data-cy="setting-only-view"
                            >
                                {isFormKnowledge ? trI18n('CM-BUTTON-PUBLIC-TO-OTHER-PRJ') : trI18n('CM-DROPDOWN-OPTION-CAN-VIEW')}
                            </MenuItem>
                        </TextField>
                    </>
                );
            case 'チケットタイプ':
            case '親チケット':
            case '子チケット':
            case 'エスカレーション先':
                return (
                    <>
                        <TextField
                            className="form-control--wrap form-control--hg32"
                            value={publicForCustomer}
                            disabled={isDisabledInput}
                            select
                            variant="outlined"
                            onChange={event => onChangeSettingPublicForCustomer(event)}
                            data-cy="setting-public-for-customer"
                        >
                            <MenuItem value={Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW} data-cy="setting-only-view">
                                {isFormKnowledge ? trI18n('CM-BUTTON-NOT-PUBLIC') : trI18n('CM-DROPDOWN-OPTION-DO-NOT-SHOW')}
                            </MenuItem>
                        </TextField>
                    </>
                );
            case '代理投稿者':
            case '担当者':
            case 'ステータス':
                return (
                    <>
                        <TextField
                            className="form-control--wrap form-control--hg32"
                            value={publicForCustomer}
                            disabled={isDisabledInput}
                            select
                            variant="outlined"
                            onChange={event => onChangeSettingPublicForCustomer(event)}
                            data-cy="setting-public-for-customer"
                        >
                            <MenuItem value={Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW} data-cy="setting-not-show">
                                {isFormKnowledge ? trI18n('CM-BUTTON-NOT-PUBLIC') : trI18n('CM-DROPDOWN-OPTION-DO-NOT-SHOW')}
                            </MenuItem>
                            <MenuItem 
                                value={isFormKnowledge ?
                                    Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER: Constant.SETTING_FORM_DEFAULT.READ_ONLY
                                }
                                data-cy="setting-only-view"
                            >
                                {isFormKnowledge ? trI18n('CM-BUTTON-PUBLIC-TO-OTHER-PRJ') : trI18n('CM-DROPDOWN-OPTION-CAN-VIEW')}
                            </MenuItem>
                        </TextField>
                    </>
                );
            default:
                return (
                    <>
                        <TextField
                            className="form-control--wrap form-control--hg32"
                            value={publicForCustomer}
                            disabled={isDisabledInput}
                            select
                            variant="outlined"
                            onChange={event => onChangeSettingPublicForCustomer(event)}
                            data-cy="setting-public-for-customer"
                        >
                            <MenuItem selected value={Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW} data-cy="setting-not-show">
                                {isFormKnowledge ? trI18n('CM-BUTTON-NOT-PUBLIC') : trI18n('CM-DROPDOWN-OPTION-DO-NOT-SHOW')}
                            </MenuItem>
                            {!isFormKnowledge && (
                                <MenuItem value={Constant.SETTING_FORM_DEFAULT.READ_ONLY} data-cy="setting-only-view">
                                    {trI18n('CM-DROPDOWN-OPTION-CAN-VIEW')}
                                </MenuItem>
                            )}
                            {props.addFormType !== Constant.FORM_TYPE.FORM_REQ_NOTICE && (
                                <MenuItem value={Constant.SETTING_FORM_DEFAULT.PUBLIC_FOR_CUSTOMER} data-cy="setting-view-edit">
                                    {isFormKnowledge ? trI18n('CM-BUTTON-PUBLIC-TO-OTHER-PRJ') : trI18n('DROPDOWN-OPTION-CAN-VIEW-EDIT')}
                                </MenuItem>
                            )}
                        </TextField>
                    </>
                );
        }
    };

    useEffect(() => {
        if (
            props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
            props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM
        ) {
            let cloneFieldAddList = cloneDeep(props.fieldAddList);

            cloneFieldAddList[indexAddField].required = fieldRequire;
            cloneFieldAddList[indexAddField].publicForCustomer = publicForCustomer;
            props.setFieldAddList(cloneFieldAddList);

            let cloneFieldListInProject = cloneDeep(fieldListInUsingProject);
            const indexFieldInUsingProject = Utils.findIndexInArrayById(
                props.currentAddField.id,
                cloneFieldListInProject
            );
            if (indexFieldInUsingProject !== -1) {
                cloneFieldListInProject[indexFieldInUsingProject].required = fieldRequire;
                cloneFieldListInProject[
                    indexFieldInUsingProject
                ].publicForCustomer = publicForCustomer;
            }
            props.setListFieldInProject(cloneFieldListInProject);

            let cloneFieldAddToForm = cloneDeep(fieldListAddToForm);
            const indexFieldAddToForm = Utils.findIndexInArrayById(
                props.currentAddField.id,
                cloneFieldAddToForm
            );
            if (indexFieldAddToForm !== -1) {
                cloneFieldAddToForm[indexFieldAddToForm].required = fieldRequire;
                cloneFieldAddToForm[indexFieldAddToForm].publicForCustomer = publicForCustomer;
            }
            props.setListFieldAddToForm(cloneFieldAddToForm);
        }
    }, [fieldRequire, publicForCustomer]);

    return (
        <div className="input-req">
            <div className="input-check">
                <p className="input-check-text">{tr('入力必須')}</p>
                <div className="switch-check">
                    <input
                        data-cy="setting-form-input-switch"
                        type="checkbox"
                        id={`${props.currentAddField.id}_fieldRequire`}
                        checked={fieldRequire}
                        disabled={checkDisabledInput(false)}
                        onChange={onChangeSettingFieldRequire}
                    />
                    <label htmlFor={`${props.currentAddField.id}_fieldRequire`}></label>
                </div>
            </div>
            {/* hidden if currentData is attachments field  */}
            {currentFieldData.sysField !== 'attachments' && !isTaskForm && (
                <div className="input-operation">
                    <div className="input-dFlex">
                        <label className="input-label">
                            {isFormKnowledge
                                ? trI18n('CM-DROPDOWN-OPTION-OTHER-PRJ-ACTION')
                                : trI18n('CM-DROPDOWN-OPTION-CUSTOMER-ACTION')}
                        </label>
                        <div className="input-control">
                            {setCustomerAction(
                                Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    currentFieldData.name
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Dialog
                open={open}
                onClose={() => handleCloseConfirmModal()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="alert-dialog-delete-addition-user"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-delete-addition-user-content">
                        {trI18n('MSG-ERROR-WHEN-EDIT-TITLE-FIELD-TO-NOT-PUBLIC')
                            .replace('{{field_name}}', name?.jp?.text)
                            .replace('{{field_label}}', () => {
                                return isFormKnowledge
                                    ? trI18n('CM-DROPDOWN-OPTION-OTHER-PRJ-ACTION')
                                    : trI18n('CM-DROPDOWN-OPTION-CUSTOMER-ACTION');
                            })
                            .replace('{{field_item_value}}', () => {
                                return isFormKnowledge
                                    ? trI18n('CM-BUTTON-NOT-PUBLIC')
                                    : trI18n('CM-DROPDOWN-OPTION-DO-NOT-SHOW');
                            })}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="confirm-delete-user-dialog-action">
                    <Button
                        onClick={e => {
                            setPublicForCustomer(Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW);
                            setOpen(false);
                        }}
                        autoFocus
                        className="btn-handle-delete-user btn-handle-delete-user-agree"
                    >
                        {trI18n('COMBTN002')}
                    </Button>
                    <Button
                        onClick={(event, reason) => handleCloseConfirmModal(event, reason)}
                        className="btn-handle-delete-user btn-handle-delete-user-disagree"
                    >
                        {trI18n('COMBTN007')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
